"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitlistFilterInternalOptionsEnum = exports.WaitlistFilterOptionsEnum = exports.WaitlistEntryOrderBy = exports.WaitlistFilterParamsEnum = exports.WaitlistOwnerTypeEnum = void 0;
var WaitlistOwnerTypeEnum;
(function (WaitlistOwnerTypeEnum) {
    WaitlistOwnerTypeEnum["CUSTOMER"] = "customer";
})(WaitlistOwnerTypeEnum = exports.WaitlistOwnerTypeEnum || (exports.WaitlistOwnerTypeEnum = {}));
var WaitlistFilterParamsEnum;
(function (WaitlistFilterParamsEnum) {
    WaitlistFilterParamsEnum["PRODUCT_IDS"] = "productIds";
    WaitlistFilterParamsEnum["RESOURCES"] = "resources";
})(WaitlistFilterParamsEnum = exports.WaitlistFilterParamsEnum || (exports.WaitlistFilterParamsEnum = {}));
var WaitlistEntryOrderBy;
(function (WaitlistEntryOrderBy) {
    WaitlistEntryOrderBy["CREATED_AT"] = "createdAt";
    WaitlistEntryOrderBy["OWNER_NAME"] = "ownerName";
    WaitlistEntryOrderBy["PRODUCT_NAME"] = "productName";
})(WaitlistEntryOrderBy = exports.WaitlistEntryOrderBy || (exports.WaitlistEntryOrderBy = {}));
var WaitlistFilterOptionsEnum;
(function (WaitlistFilterOptionsEnum) {
    WaitlistFilterOptionsEnum["PRODUCTS_IDS"] = "productsIds";
    WaitlistFilterOptionsEnum["RESOURCES_IDS"] = "resourcesIds";
})(WaitlistFilterOptionsEnum = exports.WaitlistFilterOptionsEnum || (exports.WaitlistFilterOptionsEnum = {}));
var WaitlistFilterInternalOptionsEnum;
(function (WaitlistFilterInternalOptionsEnum) {
    WaitlistFilterInternalOptionsEnum["SEGMENTS_IDS"] = "segmentsIds";
    WaitlistFilterInternalOptionsEnum["EVENTS_IDS"] = "eventsIds";
})(WaitlistFilterInternalOptionsEnum = exports.WaitlistFilterInternalOptionsEnum || (exports.WaitlistFilterInternalOptionsEnum = {}));
//# sourceMappingURL=waitlist.enums.js.map